import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
/**
 * Los tokens van antes que el resto de hojas: definen las variables CSS que
 * consumen Tailwind y MUI. Al ser custom properties no hay conflicto de
 * cascada, pero mantenerlas primero deja claro quien manda.
 */
import './theme/tokens.css';
import './global.css';
import './i18n';
import { LoginProvider } from 'Contexts/AuthProvider/AuthProvider';
import { DialogProvider } from 'Contexts/Modals/ModalProvider';
import { EnrollProvider } from 'Contexts/EnrollProvider/EnrollProvider';
import { ThemeModeProvider } from './theme';

const container = document.getElementById('root');
const root = createRoot(container!);

/**
 * `ThemeModeProvider` va por fuera de todo: inyecta el tema de MUI y fija
 * `data-theme` en `<html>`, asi que ningun componente puede quedar fuera.
 */
root.render(
  <ThemeModeProvider>
    <BrowserRouter>
      <LoginProvider>
        <EnrollProvider>
          <DialogProvider>
            <App />
          </DialogProvider>
        </EnrollProvider>
      </LoginProvider>
    </BrowserRouter>
  </ThemeModeProvider>
);

reportWebVitals();
